import { RequestService } from '../../../../../common/services/RequestService';
import { MODELS_GET } from '../../constants';

export const getModelsRequest = payload => {
  return RequestService.get(MODELS_GET);
};
